<template>
  <div ref="wrapper">
    <div class="empty:tw-hidden" @click="handleToggleDropdown">
      <slot name="trigger"> </slot>
    </div>

    <div
      v-show="isScopedDropdownOpen"
      class="empty:tw-hidden"
      @click="handleToggleDropdown"
    >
      <slot name="custom-trigger-open"></slot>
    </div>

    <div
      v-show="!isScopedDropdownOpen"
      class="empty:tw-hidden"
      @click="handleToggleDropdown"
    >
      <slot name="custom-trigger-closed"></slot>
    </div>

    <div v-show="isScopedDropdownOpen">
      <slot name="menu"> </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { onClickOutside } from '@vueuse/core'

import { useDropdown } from '@app/shared/pinia/dropdown'
import getPiniaInstance from '@app/shared/pinia/instance'

interface Props {
  dropdownId: string
  isDisabled?: boolean
}

const props = defineProps<Props>()

const wrapper = ref<HTMLElement | null>(null)

onClickOutside(wrapper, () => {
  if (isScopedDropdownOpen.value) {
    handleCloseDropdown()
  }
})

const dropdownStore = useDropdown(getPiniaInstance())

const isScopedDropdownOpen = computed(
  () => dropdownStore.currentDropdownId === props.dropdownId
)

function handleCloseDropdown() {
  dropdownStore.closeDropdown()
}

function handleToggleDropdown() {
  if (!props.isDisabled) {
    dropdownStore.toggleDropdown(props.dropdownId)
  }
}
</script>
